import {
  Routes,
  Route,
} from 'react-router-dom'
import LetterScreen from "./Letter";
import ContactScreen from "./Contact";
import PrivacyScreen from './Privacy';


function App() {
  return (
    <Routes>
      <Route path='*' element={<LetterScreen />} />
      <Route exact path='/contact' element={<ContactScreen />} />
      <Route exact path='/privacy-policy' element={<PrivacyScreen />} />
    </Routes>
  );
}

export default App;
